<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Galeria de fotos" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <form class="forms-sample">
                    <div class="form-row">
                      <div class="form-group">
                        <label for="inputDate" class="required">Data</label>
                        <Datefield v-model="formulario.date" :classField="'form-control'" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"/>
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.date}}</div>
                      </div>
                      <div class="form-group col-sm">
                        <label for="inputTitle" class="required">Título</label>
                        <input type="text" v-model="formulario.title" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputTitle">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.title}}</div>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="textAreaDescription" class="required">Síntese</label>
                        <textarea class="form-control" rows="7" v-model="formulario.description" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" id="textAreaDescription"></textarea>
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.description}}</div>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="inputPhoto_album" :class= "estaEditando ? '' : 'required' ">Capa</label>
                        <UploadFile
                          v-model="formulario.photo_album"
                          :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                          :accept="'image/jpeg, image/png'"
                        />
                        <div div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.photo_album}}</div>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="inputPhotos">Fotos</label>
                        <UploadFile
                          v-model="formulario.photos"
                          :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                          :accept="'image/jpeg, image/png'"
                          :multiple="'multiple'"
                        />
                        <div div class="avisoDanger text-left mt-1">{{retorno.listaDeErros['photos.*']}}</div>
                      </div>
                      <div class="row">
                        <div v-for="(foto) in listaFotosAlbum" :key="foto.id" class="col-8 col-sm-6 col-md-3">
                          <div class="card bg-light d-flex flex-fill mt-2 mr-2 text-center">
                            <div class="card-header titulos-conteudo border-bottom-0"></div>
                            <div class="card-body pt-0">
                              <div class="row">
                                <div class="col-12 ">
                                  <imageStream class="img-fluid mb-2" :imageStream="foto.image_file_name" alt="Foto" height="500" width="500" />
                                </div>
                              </div>
                            </div>
                            <div class="card-footer">
                              <div class="text-right">
                                <div class="row btn-group btn-group-justified" role="group">
                                  <div><b-button class="botoes" variant="outline-danger btn-sm mt-2" @click="showModalExcluirFotosAlbum(foto.id)" :disabled="flagsDeControle.carregandoDados.status || flagsDeControle.manipulandoDados.status">Excluir</b-button></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div><!-- end row -->
                      <b-modal id="modalExcluirFoto" size="sm" cancel-title='Fechar' ok-title='Ok' @ok="excluirFotoDoAlbum">
                        <form>
                          <span class="textos">Confirma a exclusão da foto?</span>
                        </form>
                        <template v-slot:modal-footer="{ ok, cancel }">
                          <b-button class="botoes" variant="outline-success btn-sm" @click="ok()">Confirmar</b-button>
                          <b-button class="botoes" variant="outline-primary btn-sm" @click="cancel()">Fechar</b-button>
                        </template>
                      </b-modal>
                      <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center col-12">
                        <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                        <b-spinner class="ml-2" variant="danger"></b-spinner>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="card-footer">
                  <div class="text-right">
                    <b-button class="botoes" variant="outline-success btn-sm mr-1" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarRegistro()">Salvar</b-button>
                    <router-link class="" to="/administracao-galeria-fotos">
                      <b-button class="botoes" variant="outline-primary btn-sm" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- /.row -->
        </div><!-- /.card-body -->
      </div><!-- /.card -->
    </section><!-- /.content -->
  </div><!-- /.content-wrapper -->
</div><!-- ./wrapper -->
</template>

<script>
import GaleriaFotos from './js/cadastro-galeriaFotos'
export default GaleriaFotos
</script>

<style scoped>
@import "./scss/galeriaFotos.scss";
</style>
